export interface BankInfo {
  bank_name: string;
  acc_no: string;
  acc_holder_name: string;
  cin_no: string;
  iban: string;
  swift_code: string;
  branch_code: string;
}

export interface PersonalInfo {
  phone: {
    code: string;
    number: string;
  };
  profile_img: File | string;
  profile_img_url?: string;
  username: string;
  first_name: string;
  last_name: string;
  country: string;
  birthday?: Date;
  national_identity_no?: string;
  stage_name: string;
  description: string;
}

export interface Profile {
  phone_no: string;
  username: string;
  name: string;
  country: {
    value: string;
    label: string;
  };
  birthday?: Date;
  national_identity_no?: number;
  stage_name: string;
  profile_img?: File | string;
  profile_img_url?: string;
}

export interface ContactInfo {
  username: string;
  name: string;
  email: string;
  phone_no: string;
  issue: string;
}
export const INITIAL_CONTACT_INFO_VALUES = {
  username: '',
  name: '',
  email: '',
  phone_no: '',
  issue: '',
};

export const INITIAL_PROFILE_VALUES = {
  phone_no: '',
  username: '',
  name: '',
  country: {
    value: '',
    label: '',
  },
  stage_name: '',
  profile_img: '',
  profile_img_url: '',
};

export const INITIAL_PERSONAL_INFO_VALUES = {
  first_name: '',
  last_name: '',
  country: '',
  national_identity_no: '',
  stage_name: '',
  description: '',
  phone: {
    code: '+972',
    number: '',
  },
  profile_img: '',
  profile_img_url: '',
  username: '',
};

export const INITIAL_BANK_INFO_VALUES = {
  bank_name: '',
  acc_no: '',
  acc_holder_name: '',
  cin_no: '',
  iban: '',
  swift_code: '',
  branch_code: '',
};
